import { render } from "./AllTicketsPage.vue?vue&type=template&id=788ed767&scoped=true"
import script from "./AllTicketsPage.vue?vue&type=script&lang=js"
export * from "./AllTicketsPage.vue?vue&type=script&lang=js"

import "./AllTicketsPage.vue?vue&type=style&index=0&id=788ed767&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788ed767"]])

export default __exports__